const locales = () => (window.userLocale ? [window.userLocale, 'sv-SE', 'en-GB'] : ['sv-SE', 'en-GB']);

/** Rounded to `stepM`; metres below 1 km, kilometres with one decimal above. */
export function formatDistance(distanceM: number, stepM = 10): string {
	const rounded = Math.max(stepM, Math.round(distanceM / stepM) * stepM);
	if (rounded < 1000) {
		return new Intl.NumberFormat(locales(), { style: 'unit', unit: 'meter', unitDisplay: 'short' }).format(rounded);
	}
	return new Intl.NumberFormat(locales(), {
		style: 'unit',
		unit: 'kilometer',
		unitDisplay: 'short',
		maximumFractionDigits: 1
	}).format(distanceM / 1000);
}
